import style from './AddCardPage.css';
import Title from '../../components/shared/Typography/Title';
import List from '../../components/shared/List/List';
import ListItem from '../../components/shared/List/ListItem';
import CardThumbnail from '../../components/shared/CardThumbnail/CardThumbnail';
import useTranslation from '../../localization/i18n.context';
import NavigationUtils from '../../utils/navigation.utils';

export default function AddCardView({ cards = [] }) {
  const { t, getOrganization } = useTranslation();
  return (
    <main className={style.main}>
      <Title text={t('Select a card to add')} className={style['page-title']} />
      <List data-testid='card-list'>
        {cards.map(card => (
          <ListItem
            title={getOrganization(card.organizationCode)}
            subtitle={card.description}
            icon={
              <CardThumbnail
                organization={card.organizationCode}
                size={CardThumbnail.Size.SMALL}
              />
            }
            actionable
            size={ListItem.Size.SMALL}
            onClick={() => {
              NavigationUtils.navigate(NavigationUtils.Routes.KYC, false, {
                organization: card.organizationCode,
              });
            }}
            testData={{
              itemTestId: 'card',
              titleTestId: 'card-organization',
              iconTestId: 'card-icon',
            }}
          />
        ))}
      </List>
    </main>
  );
}
